var React = require('react');

function TimeInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M16 9L14 10V16V18H16H23L22 16H16V9Z","fill":"#21A038","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M6 16C6 10.4772 10.4772 6 16 6C21.5081 6 25.9761 10.4533 25.9999 15.9558L25.9959 16H28C28 9.37258 22.6274 4 16 4C9.37258 4 4 9.37258 4 16C4 22.6274 9.37258 28 16 28C21.8834 28 26.776 23.767 27.8022 18.1807L27.8104 18.1358L27.8145 18.0903L27.8227 18H25.8002C24.8741 22.5644 20.8373 26 16 26C10.4772 26 6 21.5228 6 16Z","fill":"#333F48","key":1})]);
}

TimeInline.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none"};

module.exports = TimeInline;

TimeInline.default = TimeInline;
